module.exports = __webpack_public_path__ + "static/media/sentimage.f8916075.svg";